import {
    FlexiCancelButton,
    FormPageLayout,
    PlatformLoader
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import {RecordForm} from "../forms/RecordForm.tsx";
import {useEffect} from "react";
import {useUserProfileAttributes} from "../hooks/useUserProfileAttributes.ts";
import {
    UserProfileAttribute,
    UserProfileAttributes
} from "../types.ts";
import {useUserProfileAttribute} from "../hooks/useUserProfileAttribute.ts";


export const EditPage = () => {

    const navigate = useNavigate();

    const {
        items,
        fetchRecords,
    } = useUserProfileAttributes()

    const {
        updateRecord
    } = useUserProfileAttribute()

    useEffect(() => {
        fetchRecords()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleSubmit = async (values: UserProfileAttributes) => {

        Object.keys(values)
              .forEach(key => {
                  updateRecord(key, {
                      id: key,
                      name: key,
                      value: values[key] as string | undefined
                  });
              })


    }


    if (!items || items.length === 0) {
        return <PlatformLoader message={'Loading attributes...Please, wait!'}/>
    }

    const userProfileAttributes = items.reduce((acc: UserProfileAttributes, curr: UserProfileAttribute) => {
        acc[curr.name as string] = curr.value;
        return acc;
    }, {})

    return (
        <FormPageLayout
            title={'Update Profile'}
            tools={[<FlexiCancelButton onClick={() => navigate('/user-profile')}>Cancel</FlexiCancelButton>]}>
            <RecordForm
                record={userProfileAttributes}
                handleSubmit={handleSubmit}
            />
        </FormPageLayout>
    );
};
